<template>
  <div class="rj-col-1">
    <div class="rj-baseinfo">
      <div class="rj-baseinfo__label">
        是否使用返利<span class="required">*</span>：
      </div>
      <div class="rj-baseinfo__item">
        <el-form-item style="display: inline-block">
          <el-radio-group v-model="form.isRebate" :disabled="true" @change="changisRebate">
            <el-radio :label="true">
              是
            </el-radio>
            <el-radio :label="false">
              否
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="form.isRebate">
          <el-input-number v-model.number="form.rebateAmount" :controls="false" :min="0" label="描述文字" style="margin-left: 15px" :disabled="true" @change="changrebateAmount" />
          <span style="margin-left: 15px">剩余返利可用金额：<span style="color: #409EFF">{{ form.remainderRebateAmount }}元</span></span>
        </template>
      </div>
    </div>
  </div>
</template>
<script type="es6">
// import { MathMulti } from '@/libs/util';
import { getChannelRebate } from '@/API';
export default {
  data () {
    return {
      list: [],
      loading: false
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {},
  computed: {
    // allowRebateAmount () {
    //   if (this.form.remainderRebateAmount) {
    //     let allowremainder = MathMulti(this.form.remainderRebateAmount, 0.3);
    //     if (allowremainder < this.form.contractSum) {
    //       return this.form.contractSum;
    //     }
    //     return allowremainder;
    //   }
    //   return 0;
    // }
  },
  methods: {
    changrebateAmount (val) {
      // 使用返利值变化
      this.$emit('changRebateAmount', val);
    },
    changisRebate (val) {
      if (!val) {
        this.form.rebateAmount = 0;
      }
    },
    changeEndCustomer (val) {
      // 更改最终用户 重新查询可用返利
      this.form.rebateAmount = 0;
      let params = {
        isNewCreateContract: val.isNewContract,
        'supplyUnitName': val.supplyUnitName,
        'orderUnitCode': val.orderUnitCode,
        'orderUnitName': val.orderUnit,
        'finalCustomerCode': '',
        'finalCustomerName': val.finalCustomer,
        'contractType': val.contractType,
        'isDistributorParticipate': val.isDistributorParticipate,
        'isIntegratorParticipate': val.isIntegratorParticipate,
        'integratorType': val.integratorType
      };
      getChannelRebate(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.form.remainderRebateAmount = json.data;
        }
      }).catch(() => {

      });
    }
  },
  mounted () {
  }
};
</script>
<style lang="less"></style>
